export enum ManagementItemDeviceTypes {
  BARRIER = 'Barrier',
  DEPOSITOR = 'Depositor',
  DETECTOR = 'Detector',
  DOOR = 'Door',
  ENGINE = 'Engine',
  OFFLINE_SERVER = 'Offline-Server',
  PALM = 'Palm',
  PASSAGE = 'Passage',
  TERMINAL = 'Terminal',
}
